module.exports = __webpack_public_path__ + "media/images/emblems/Attinghausen-coat_of_arms-6e0279302368da19b4dfdf736a7aad26.svg";